core.filter('nl2br', function() {
    return function(input) {
        if (input !== void 0 && typeof input === 'string') {
            return input.replace(/(\n)|(\r)/g, '<br>');
        }
        return input;
    };
});